import { LinearProgress, Typography } from "@mui/material";
import { type ReactNode } from "react";
import Global from "./Global";
import {globalStyles} from "../styles/global.styles";

export default function GlobalLoading({ children }: { children?: ReactNode }) {
  return (
    <Global>
      <Typography variant="h4">Guude AI</Typography>
      <LinearProgress color="secondary" sx={globalStyles.globalLoading.linearProgress} />
      {children}
    </Global>
  );
}
